export default {
  inputBorder: '3px solid'
}



// WEBPACK FOOTER //
// ./src/core/theme/mini/miniBorders.js